import { FlexibleDates } from './actionTypes';
import { TripType } from '../../models';

// Multi-destinations and upsell will use "one way" fares
export const getTripTypeKey = (tripType) => tripType === TripType.ROUND_TRIP ? 'ROUND_TRIP' : 'ONE_WAY';
export const cacheKey = (origin, destination, tripType) => `${origin.geoNodeId}-${destination.geoNodeId}-${getTripTypeKey(tripType)}`;

const requestFlexibleDates = (state, { origin, destination, date, tripType }) => {
    const key = cacheKey(origin, destination, tripType);
    const cache = state[key] || { status: {} };
    cache.status[date.getTime()] = 'loading';

    return {
        ...state,
        [key]: cache,
    };
};

const receiveFlexibleDates = (state, { origin, destination, date, tripType, data }) => {
    const key = cacheKey(origin, destination, tripType);
    const { prices } = data;
    const cache = state[key];
    cache.status[date.getTime()] = 'loaded';
    cache.data = {
        ...cache.data,
        ...prices,
    };

    return {
        ...state,
        [key]: cache,
    };
};

const failedFlexibleDates = (state, { origin, destination, date, tripType }) => {
    const key = cacheKey(origin, destination, tripType);
    const cache = state[key];
    cache.status[date.getTime()] = 'loaded';
    cache.data = { ...cache.data };
    return {
        ...state,
        [key]: cache,
    };
};

export default function(state = {}, action) {
    switch (action.type) {
        case FlexibleDates.FAILED:
            return failedFlexibleDates(state, action.payload);
        case FlexibleDates.REQUEST:
            return requestFlexibleDates(state, action.payload);
        case FlexibleDates.RECEIVE:
            return receiveFlexibleDates(state, action.payload);
    }

    return state;
}
